const StressButton = ({numStress, mainStress}) => {
    return <div className='w-32 h-16 flex flex-row m-auto rounded-xl'>
        {[...Array(numStress)].map((_, i) => <div
            className={`m-auto ${i === mainStress ? "w-10 h-10" : "w-6 h-6"} rounded-full bg-white`}
        />)}
    </div>
}
export default StressButton;